import { useMemo } from "react";
import { BaseTableLayout, ColumnDef } from "../../components/base-table-layout";
import { TableRow } from "../../utils/tables-metadata";
import { RelatedPersonRowData } from "./related-person-rows";

export type RelatedPersonTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
  isRowViewed?: (row: TableRow) => boolean;
};

export function RelatedPersonTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Related Persons",
  isRowViewed,
}: RelatedPersonTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  const columns = useMemo(() => {
    const cols: ColumnDef<RelatedPersonRowData>[] = [
      { key: "name", header: "Name" },
      { key: "relationships", header: "Relationships" },
      { key: "contacts", header: "Contacts", hideOnSmallScreen: true },
      { key: "addresses", header: "Addresses", hideOnSmallScreen: true },
    ];

    return cols;
  }, []);

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as RelatedPersonRowData[]}
      columns={columns}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
      isRowViewed={isRowViewed}
    />
  );
}
